import { useNotificationPermissionInit } from '@/features/notifications/hooks/useNotificationPermissionInit';

export const NotificationPermissionInit = () => {
  useNotificationPermissionInit();

  return null;
};
